(() => {
  const shopifyRoot = window.Shopify?.routes?.root || "/";
  const localizedRoot = `/${shopifyRoot.split("/").filter(Boolean).join("/")}`;

  if (localizedRoot === "/") return;

  const excludedPrefixes = [
    "/admin",
    "/apps",
    "/cdn",
    "/services",
    "/tools",
    "/wpm",
  ];

  function localizeHref(anchor) {
    const rawHref = anchor.getAttribute("href");

    if (
      !rawHref ||
      !rawHref.startsWith("/") ||
      rawHref.startsWith("//") ||
      rawHref === localizedRoot ||
      rawHref.startsWith(`${localizedRoot}/`) ||
      excludedPrefixes.some((prefix) => rawHref === prefix || rawHref.startsWith(`${prefix}/`))
    ) {
      return;
    }

    anchor.setAttribute("href", `${localizedRoot}${rawHref}`);
  }

  function localizeLinks(root = document) {
    if (root instanceof HTMLAnchorElement) {
      localizeHref(root);
    }

    root.querySelectorAll?.("a[href]").forEach(localizeHref);
  }

  function init() {
    localizeLinks();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) localizeLinks(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
